import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as cloneDeep from 'lodash/cloneDeep';

import { FamilyListDropdown, ModelDropdown } from '../../models';

@Component({
	selector: 'mb-add-to-compare',
	templateUrl: './add-to-compare-model.component.html',
	styleUrls: ['./add-to-compare-model.component.scss']
})
export class AddToCompareModelComponent {
	@Input() public selectedModels: ModelDropdown[] = [];
	@Input() public familyList: FamilyListDropdown[] = [];
	@Output() public getSelectedFamilyToCompare: EventEmitter<ModelDropdown[]> = new EventEmitter<ModelDropdown[]>();

	public isCompareDropdownVisible: boolean = false;

	public addToCompare(familyToCompare: ModelDropdown): void {
		const selectedModels = cloneDeep(this.selectedModels);
		selectedModels.push(familyToCompare);
		this.getSelectedFamilyToCompare.emit(selectedModels);
	}
}
